import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {NzConfigService, NzModalService} from 'ng-zorro-antd';
import {CommonService} from '../../../services/common/common.service';

@Component({
  selector: 'app-popup-confirm',
  templateUrl: './popup-confirm.component.html',
  styleUrls: ['./popup-confirm.component.scss']
})
export class PopupConfirmComponent implements OnInit {
  isVisible = false;
  index = 1;
  name: any;
  title: any;
  data: any;
  id: any;
  // tslint:disable-next-line:variable-name
  @Output() emitData = new EventEmitter();

  constructor(
      private fb: FormBuilder,
      private modalService: NzModalService,
      private notification: NzConfigService,
      public commonService: CommonService

  ) {
  }

  ngOnInit() {
  }


  handleCancel(): void {
    this.isVisible = false;
    this.emitData.emit('cancel');
  }

  showModal(data: any) {
    this.isVisible = true;
    this.data = data;
  }

  onSubmit() {
    this.emitData.emit('confirm');
    this.isVisible = false;
  }
}
